import { RICH_MEDIA_QUILL_FORMATS } from '@shared/consts/rich-media-quill.const';

export const MailingQuillFormats: string[] = RICH_MEDIA_QUILL_FORMATS;
